import React, {RefObject} from "react"
import {Card, Form, FormInstance, Row, Select} from "antd";
import Title from "antd/es/typography/Title";
import IContentType from "../../../../../model/interface/dataStorage/IContentType";
import {API_AGGREGATION_TYPE_LIST} from "../../../../../model/constants/ApiConstant";
import FieldPicker from "../../../../shared/pickers/FieldPicker";
import {FIELD_NUMBER_TYPES} from "../../../../../model/interface/dataStorage/IField";
import Button from "../../../../shared/button/Button";
import {CloseOutlined, PlusOutlined} from "@ant-design/icons";
import IViewOptions from "../../../../../model/interface/dataStorage/view/IViewOptions";
import Utils from "../../../../../utils";
import HumanTimeConfigBuilder, {IHumanTimeConfig} from "../../../../shared/human-time/HumanTimeConfigBuilder";
import TranslationInput from "../../../../shared/input/TranslationInput";
import LocaleText from "../../../settings/dictionary/LocaleText";
import {
    VIEW_AGGREGATION_PLACEMENT_LIST
} from "../../../../../model/interface/dataStorage/view/table/IAggregationOptions";
import ColorPicker from "../../../../shared/pickers/ColorPicker";

interface IState {
    aggregations: string[]
}

interface IProps {
    contentType: IContentType
    values: IViewOptions,

    formRef: RefObject<FormInstance>
}


class AggregationProperties extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            aggregations: props.values?.aggregations ? Object.keys(props.values?.aggregations) : []
        }
    }

    static FORMAT_TYPES = {
        HUMAN_TIME: 'human-time'
    }

    buildName = (field: string, index: string) => ['options', 'aggregations', index, field]

    addAggregation = () => {
        this.setState(state => ({aggregations: [...state.aggregations, Utils.uuid()]}))
    }

    removeAggregation = (index: string) => {
        this.setState(state => ({aggregations: state.aggregations.filter(a => a !== index)}))
    }

    render() {
        const {contentType, values, formRef} = this.props
        const {aggregations} = this.state

        return (
            <>
                <Card size={"small"}>
                    <Row justify={"space-between"}>
                        <Title level={3}>Agregace</Title>
                        <Button size={"small"} type={'success'} icon={<PlusOutlined/>} onClick={this.addAggregation}/>
                    </Row>
                    {aggregations.map(a => {
                        const currentAggregation = values?.aggregations?.[a]
                        return (
                            <Card size={"small"}
                                  title={<Row justify={"space-between"}>
                                      <Title level={4}><LocaleText code={currentAggregation?.title || ''}/></Title>
                                      <Button size={"small"} type={'link'} danger icon={<CloseOutlined/>}
                                              onClick={() => this.removeAggregation(a)}/></Row>}>
                                <Form.Item label={"Pole"} name={this.buildName('field', a)}
                                           rules={[{required: true, message: 'Pole je povinné'}]}>
                                    <FieldPicker serviceClassName={contentType.fullClassName} output={'name'}
                                                 mode={"simple"}
                                                 onChange={(value) => {
                                                     const currentField = contentType.fields.find(f => f.name === value)
                                                     if (currentField && !currentAggregation?.title) {
                                                         formRef.current?.setFields([{
                                                             name: this.buildName('title', a),
                                                             value: currentField.label
                                                         }])
                                                     }
                                                 }
                                                 }
                                                 allowTypes={FIELD_NUMBER_TYPES}/>
                                </Form.Item>
                                <Form.Item label={"Typ aggregace"} name={this.buildName('type', a)}
                                           rules={[{required: true, message: 'Pole je povinné'}]}>
                                    <Select>
                                        {API_AGGREGATION_TYPE_LIST.map(o => (
                                            <Select.Option value={o.value} key={o.value}>
                                                <LocaleText code={o.label} fallback={o.labelFallback}/>
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item label={"Titulek"} name={this.buildName('title', a)}
                                           rules={[{required: true, message: 'Pole je povinné'}]}>
                                    <TranslationInput code={'configuration.view.aggregation.title' + Utils.uuid()}
                                                      preserveCode={true}/>
                                </Form.Item>
                                <Form.Item label={"Formát jako"} name={this.buildName('format', a)}>
                                    <Select>
                                        {Object.entries(AggregationProperties.FORMAT_TYPES)
                                            .map(([label, value]) => (
                                                <Select.Option value={value} key={value}>
                                                    {label}
                                                </Select.Option>
                                            ))}
                                    </Select>
                                </Form.Item>
                                {currentAggregation?.format === AggregationProperties.FORMAT_TYPES.HUMAN_TIME && (
                                    <Form.Item label={"Human time format"} name={this.buildName('humanTimeFormat', a)}
                                               rules={[{
                                                   required: true,
                                                   validator: async (rule, value: IHumanTimeConfig) => {
                                                       if (!value.interval || !value.format) {
                                                           throw new Error('Invalid config')
                                                       }
                                                   }, message: 'Pole je povinné'
                                               }]}>
                                        <HumanTimeConfigBuilder/>
                                    </Form.Item>
                                )}
                                <Form.Item label={<LocaleText code={'configuration.view.unit.aggregation.placement'}
                                                       fallback={'Umístění'}/>}
                                    name={this.buildName('placement', a)}>
                                    <Select mode={'multiple'}>
                                        {VIEW_AGGREGATION_PLACEMENT_LIST.map(item => (
                                            <Select.Option value={item.value} key={item.value}>
                                                <LocaleText code={item.label} fallback={item.labelFallback}/>
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item label={<LocaleText code={'configuration.view.unit.aggregation.background'}
                                                              fallback={'Barva pozadí'}/>}
                                           name={this.buildName('background', a)}>
                                    <ColorPicker/>
                                </Form.Item>
                                <Form.Item label={<LocaleText code={'configuration.view.unit.aggregation.color'}
                                                              fallback={'Barva textu'}/>}
                                           name={this.buildName('color', a)}>
                                    <ColorPicker/>
                                </Form.Item>
                            </Card>
                        )
                    })}
                </Card>

            </>
        )
    }
}

export default AggregationProperties